import { useRequest } from 'ahooks'
import { message } from 'antd'
import { downloadFlowExecuteLog } from '@apis/flow'
import dayjs from 'dayjs'

interface FlowLog {
  task_id: string
  flow_id: string
  start_time: string
}

export function useDownloadFlowLog() {
  const { runAsync: getFlowExecuteLogApi } = useRequest(
    downloadFlowExecuteLog,
    {
      manual: true,
    },
  )

  const downloadFlowLog = (flowLog: FlowLog) => {
    if (flowLog.task_id && flowLog.flow_id) {
      getFlowExecuteLogApi({
        flowId: flowLog.flow_id,
        taskId: flowLog.task_id,
      }).then(async res => {
        if (res) {
          try {
            const response = await fetch(res)
            const jsonData = await response.json()
            const jsonString = JSON.stringify(jsonData, null, 2)
            const blob = new Blob([jsonString], { type: 'application/json' })
            const downloadUrl = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = downloadUrl
            link.download = `日志_${dayjs(flowLog.start_time).format(
              'YYYY-MM-DD_HH-mm-ss',
            )}.json`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(downloadUrl)
          } catch (error) {
            console.error('Export failed:', error)
            message.error('下载失败')
          }
        }
      })
    } else {
      message.error('无法下载日志')
    }
  }

  return { downloadFlowLog }
}
